/* eslint-disable @typescript-eslint/no-use-before-define, react/no-unused-prop-types */

import { Box, Text } from '@chakra-ui/react';

import formatPercent from 'common/formatPercent';
import { FCWithChildren } from 'common/types';

import locales from './locales';

interface UploadingProps {
  withFlatBottom?: boolean;
}

/**
 * A component that mimics the uploading state of the Upload component
 */
const Uploading: FCWithChildren<UploadingProps> = ({ children }) => (
  <Box
    _notLast={{ borderBottomRadius: 0 }}
    background="grey.200"
    borderRadius="radius-16"
    padding="space-16"
  >
    <Box
      border="1px dashed"
      borderColor="grey.600"
      borderRadius="radius-12"
      padding="space-16"
      textAlign="center"
    >
      <Text as="span" fontWeight="weight-500" variant="primary">
        {formatPercent(1)}&nbsp;
      </Text>

      <Text as="span" variant="primary">
        {locales.uploading}
      </Text>
    </Box>

    <Box>{children}</Box>
  </Box>
);

export default Uploading;
